var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNetOperatingIncome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2446 2.00098H14.9941V18.0015H21.2446C22.7641 18.0015 23.9941 16.7715 23.9941 15.252V4.75198C23.9956 3.23098 22.7656 2.00098 21.2446 2.00098ZM20.2456 15H17.7451C17.3356 15 16.9951 14.6595 16.9951 14.25C16.9951 13.8405 17.3356 13.5 17.7451 13.5H20.2456C20.6551 13.5 20.9956 13.8405 20.9956 14.25C20.9956 14.6595 20.6551 15 20.2456 15ZM2.74507 2.00098C1.22557 2.00098 -0.00442505 3.23098 -0.00442505 4.75048V15.2505C-0.00442505 16.77 1.22557 18 2.74507 18H8.99557V2.00098H2.74507ZM6.24458 6.50098H3.74408C3.33458 6.50098 2.99408 6.16048 2.99408 5.75098C2.99408 5.34148 3.33458 5.00098 3.74408 5.00098H6.24458C6.65408 5.00098 6.99458 5.34148 6.99458 5.75098C6.99458 6.16048 6.65558 6.50098 6.24458 6.50098Z",
    fill: "#5FEDD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9956 2.00048V18.001C14.9956 19.1005 14.1061 20.0005 12.9961 20.0005H10.9951C9.89558 20.0005 8.99557 19.1005 8.99557 18.001V2.00048C8.99557 0.900979 9.89558 0.000978435 10.9951 0.000978435H12.9946C14.1046 -0.000521565 14.9956 0.899478 14.9956 2.00048Z",
    fill: "#EBF3FE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNetOperatingIncome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/net_operating_income.5bb3f9baf91a810ee361204dab3fab75.svg";